import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { OktaAuthModule } from '@okta/okta-angular';
import * as WebFont from 'webfontloader';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { extModules } from './build-specifics';
import { CoreModule } from './core/core.module';
import { PortalModule } from './portal/portal.module';
import { PublicModule } from './public/public.module';

WebFont.load({
  custom: { families: ['Material Icons'], }
});

const declarationModules = [
  BrowserModule,
  BrowserAnimationsModule,
  HttpClientModule,
  CoreModule,
  PublicModule,
  PortalModule,
  OktaAuthModule
]
@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent],
  imports: [
    ...declarationModules,
    RouterModule.forRoot(appRoutes),
    NgIdleKeepaliveModule.forRoot(),
    extModules
  ]
})
export class AppModule { }
